{
  "title": "My profile",
  "subtitle": "Your account settings",
  "fields": {
    "username": "Username",
    "role": "Role"
  },
  "password": {
    "title": "Password",
    "description": "Change regularly for security.",
    "button": "Change password",
    "current_label": "Current password",
    "new_label": "New password",
    "min_length_hint": "At least 8 characters",
    "success": "Password saved."
  },
  "language": {
    "title": "Language",
    "description": "Interface language."
  },
  "theme": {
    "title": "Color theme",
    "description": "Accent color of the interface. Applies immediately, saved in your browser."
  },
  "landing": {
    "title": "Start page",
    "description": "Which page is shown first after login.",
    "buddy": "Buddy",
    "dashboard": "Dashboard"
  },
  "backup": {
    "title": "My data",
    "description": "Export or restore all your data (GDPR Art. 20).",
    "download": "Export data",
    "downloading": "Creating…",
    "restore": "Restore",
    "restoring": "Restoring…",
    "restore_confirm": "Restore your data from this backup?\n\nExisting sessions and files are kept — new data is added.",
    "restore_done": "Restored.",
    "error": "Error: {{msg}}"
  }
}
